

































import {
  CreateTransferOutCampaignRequest,
  EbtoEmployerResult,
  EbtoEmployerSearchResult,
} from "@/admin/types";
import CampaignDetail from "@/shared/components/ebto/campaign-detail.vue";
import { Vue, Component, Watch } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEmployerStore } from "@/admin/store/employer";
import { useTransferOutStore } from "@/admin/store/transferOut";

@Component({
  components: {
    CampaignDetail
  }
})
export default class CreateTransferOutCampaign extends Vue {
  $validator: Validator;

  employerStore = useEmployerStore();
  notifierStore = useNotifierStore();
  transferOutStore = useTransferOutStore();

  pageSize = 10;
  searchTerm = "";
  selectedEmployer: EbtoEmployerResult = { id: 0, externalEmployerId: "0", name: "" };
  campaign = { name: "" } as CreateTransferOutCampaignRequest;
  hasBonusIncentive = false;
  hasSpecialOffer = false;
  hasAdminFees = false;

  employers: EbtoEmployerResult[] = [];
  employerList: EbtoEmployerResult[] = [];

  mounted (): void {
    this.fetchEmployerList();
  }

  @Watch("employerStore.ebtoEmployerSearchResult", { deep: true })
  onSearchResultsArrived (): void {
    this.employers = this.employerStore.ebtoEmployerSearchResult.employerSearchResults;
    this.employerList = this.employerList.concat(
      this.employerStore.ebtoEmployerSearchResult.employerSearchResults
    );
  }

  fetchEmployerList (): void {
    if (this.searchTerm.length >= 3) {
      this.employerStore.getEbtoEmployerSearch(this.searchTerm).catch(this.handleError);
    }
  }

  handleError (err: any): void {
    this.showError(
      (err && err.errorMessage) ||
      "Error processing your request. Please try again later"
    );
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  selectEmployer () {
    const employer = this.employerList.find(
      emp => emp.id.toString() === this.searchTerm.split("-")[0].trim()
    );
    if (employer) {
      this.selectedEmployer = employer;
      this.searchTerm = "";
    } else {
      this.showError("Employer not found. Please select from the search list.");
    }
  }
}
